module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mps-entity-editor vue-rqf bg-loading",
    attrs: {
      "loading": _vm.$root.ui.loading
    }
  }, [_c('div', {
    staticClass: "mps-admin-container"
  }, [_c('h4', [_vm._v("Innstillinger"), (_vm.workshop.id) ? _c('span', {
    domProps: {
      "textContent": _vm._s(' for ' + _vm.workshop.name)
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-name"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.name),
      expression: "workshop.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('name')
    },
    attrs: {
      "id": "ws-name",
      "name": "name",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.workshop.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('name'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-slug"
    }
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.slug),
      expression: "workshop.slug"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|slug'),
      expression: "'required|slug'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('slug')
    },
    attrs: {
      "id": "ws-slug",
      "name": "slug",
      "type": "text",
      "placeholder": "Slug"
    },
    domProps: {
      "value": (_vm.workshop.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "slug", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('slug')),
      expression: "errors.has('slug')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('slug'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-email"
    }
  }, [_vm._v("Epost")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.email),
      expression: "workshop.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "id": "ws-email",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.workshop.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('email'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-contact-email"
    }
  }, [_vm._v("Kontakt Epost")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.contact_email),
      expression: "workshop.contact_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('contact_email')
    },
    attrs: {
      "id": "ws-contact-email",
      "name": "contact_email",
      "type": "email",
      "placeholder": "Contact email"
    },
    domProps: {
      "value": (_vm.workshop.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "contact_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contact_email')),
      expression: "errors.has('contact_email')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('contact_email'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-phone"
    }
  }, [_vm._v("Telefon")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.phone),
      expression: "workshop.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[\d\s\+]+$/
      }),
      expression: "{required:true, regex: /^[\\d\\s\\+]+$/}"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('phone')
    },
    attrs: {
      "id": "ws-phone",
      "name": "phone",
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.workshop.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('phone'))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-city"
    }
  }, [_vm._v("By")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.city),
      expression: "workshop.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('city')
    },
    attrs: {
      "id": "ws-city",
      "name": "city",
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.workshop.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('city'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-city"
    }
  }, [_vm._v("Gate")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.street),
      expression: "workshop.street"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('street')
    },
    attrs: {
      "id": "ws-street",
      "name": "street",
      "type": "text",
      "placeholder": "Street"
    },
    domProps: {
      "value": (_vm.workshop.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('street')),
      expression: "errors.has('street')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('street'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-postal"
    }
  }, [_vm._v("Postnummer")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.postal),
      expression: "workshop.postal"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\d{4}$/
      }),
      expression: "{required:true, regex: /^\\d{4}$/}"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('postal')
    },
    attrs: {
      "id": "ws-postal",
      "name": "postal",
      "type": "text",
      "placeholder": "Postal"
    },
    domProps: {
      "value": (_vm.workshop.postal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "postal", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('postal')),
      expression: "errors.has('postal')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('postal'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-county"
    }
  }, [_vm._v("Fylke")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.county),
      expression: "workshop.county"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('county')
    },
    attrs: {
      "id": "ws-county",
      "name": "county",
      "type": "text",
      "placeholder": "County"
    },
    domProps: {
      "value": (_vm.workshop.county)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "county", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('county')),
      expression: "errors.has('county')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('county'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-opening-times"
    }
  }, [_vm._v("Åpningstider")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.opening_times),
      expression: "workshop.opening_times"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('opening_times')
    },
    attrs: {
      "id": "ws-opening-times",
      "name": "opening_times",
      "type": "text",
      "placeholder": "Opening times"
    },
    domProps: {
      "value": (_vm.workshop.opening_times)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "opening_times", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('opening_times')),
      expression: "errors.has('opening_times')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('opening_times'))
    }
  })])]), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-longitude"
    }
  }, [_vm._v("Lengdegrad")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.longitude),
      expression: "workshop.longitude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\d{1,3}(\.\d+)?$/
      }),
      expression: "{required:true, regex: /^\\d{1,3}(\\.\\d+)?$/}"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('longitude')
    },
    attrs: {
      "id": "ws-longitude",
      "name": "longitude",
      "type": "text",
      "placeholder": "Longitude"
    },
    domProps: {
      "value": (_vm.workshop.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "longitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('longitude')),
      expression: "errors.has('longitude')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('longitude'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-latitude"
    }
  }, [_vm._v("Breddegrad")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.latitude),
      expression: "workshop.latitude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\d{1,3}(\.\d+)?$/
      }),
      expression: "{required:true, regex: /^\\d{1,3}(\\.\\d+)?$/}"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('latitude')
    },
    attrs: {
      "id": "ws-latitude",
      "name": "latitude",
      "type": "text",
      "placeholder": "Latitude"
    },
    domProps: {
      "value": (_vm.workshop.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "latitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('latitude')),
      expression: "errors.has('latitude')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('latitude'))
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-latitude"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    class: ['mps-input-wrap', 'mps-admin-select']
  }, [_c('v-select', {
    attrs: {
      "options": _vm.statuses
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.$root.isWorkshopUser()) ? _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-href"
    }
  }, [_vm._v("Landingside")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.href),
      expression: "workshop.href"
    }],
    class: {
      'input': true
    },
    attrs: {
      "id": "ws-href",
      "name": "href",
      "type": "text",
      "placeholder": "Landing page"
    },
    domProps: {
      "value": (_vm.workshop.href)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workshop, "href", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: ['mps-input-wrap', 'mps-admin-select']
  }, [_c('v-select', {
    attrs: {
      "id": "ws-fleet_status",
      "options": _vm.fleet_statuses
    },
    model: {
      value: (_vm.fleet_status),
      callback: function($$v) {
        _vm.fleet_status = $$v
      },
      expression: "fleet_status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workshop.is_svipps_partner),
      expression: "workshop.is_svipps_partner"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "ws-is_svipps_partner",
      "name": "is_svipps_partner",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.workshop.is_svipps_partner) ? _vm._i(_vm.workshop.is_svipps_partner, null) > -1 : _vm._q(_vm.workshop.is_svipps_partner, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.workshop.is_svipps_partner,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.workshop, "is_svipps_partner", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.workshop, "is_svipps_partner", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.workshop, "is_svipps_partner", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Autosvar-tekster")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('ul', {
    staticClass: "mps-damage-offer-texts-editor"
  }, [_vm._l((_vm.damageOfferTexts), function(item, idx) {
    return [_c('li', [_c('span', {
      on: {
        "click": function($event) {
          return _vm.removeDamageOfferText(idx)
        }
      }
    }, [_vm._v("x")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.damageOfferTexts[idx]),
        expression: "damageOfferTexts[idx]"
      }],
      domProps: {
        "value": (_vm.damageOfferTexts[idx])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.damageOfferTexts, idx, $event.target.value)
        }
      }
    })])]
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "mps-admin-btn big",
    on: {
      "click": _vm.addDamageOfferText
    }
  }, [_vm._v("Legg til")])])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Svar til kunden")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('ul', {
    staticClass: "mps-damage-offer-texts-editor"
  }, [_vm._l((_vm.offerTexts), function(item, idx) {
    return [_c('li', [_c('span', {
      on: {
        "click": function($event) {
          return _vm.removeOfferText(idx)
        }
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.send_offer),
        expression: "item.send_offer"
      }],
      attrs: {
        "true-value": "1",
        "false-value": "0",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.send_offer) ? _vm._i(item.send_offer, null) > -1 : _vm._q(item.send_offer, "1")
      },
      on: {
        "change": function($event) {
          var $$a = item.send_offer,
            $$el = $event.target,
            $$c = $$el.checked ? ("1") : ("0");
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "send_offer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "send_offer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "send_offer", $$c)
          }
        }
      }
    }), _vm._v("\n                Send offer\n              ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      class: {
        'input': true
      },
      attrs: {
        "type": "text",
        "placeholder": "Title"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      attrs: {
        "placeholder": "Text"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    })])]
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "mps-admin-btn big",
    on: {
      "click": _vm.addOfferText
    }
  }, [_vm._v("Legg til")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "mps-admin-btn big",
    attrs: {
      "disabled": _vm.errors.any() || _vm.$root.ui.loading
    },
    on: {
      "click": _vm.saveWorkshop
    }
  }, [_vm._v("Lagre")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-fleet_status"
    }
  }, [_c('span', [_vm._v("Fleet status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": "ws-is_svipps_partner"
    }
  }, [_c('span', [_vm._v("Svipps partner")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-399abd18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Workshop.vue
// module id = 110
// module chunks = 0